var map = {
	"./alfa_romeo.png": "49f4",
	"./alphatauri.png": "80bd",
	"./alpine.png": "ef47",
	"./aston_martin.png": "432e",
	"./ferrari.png": "1e43",
	"./haas_f1_team.png": "092f",
	"./mclaren.png": "0e00",
	"./mercedes.png": "9694",
	"./red_bull_racing.png": "a85b",
	"./williams.png": "f149"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e54";